import { getButtonList} from "../../service/dashboard";
// import moment from "moment";

const dict = {
  namespaced: true,
  state: {
    typeDict: [],
    threatId: "123456"
    // districts: [],
    // miits: [],
    // assetTypes: [],
    // dangerTypes: [],
    // eventLevels: [],
    // eventSource: [],
    // eventStatus: [],
    // eventTypes: [],
    // protocol: [],
    // vulLevels: [],
    // time: [
    //     moment().startOf("day").subtract(1, "months").valueOf(),
    //     moment().endOf("day").valueOf()
    // ],
    // pickerOptions: {
    //     shortcuts: [{
    //         text: "最近一周",
    //         onClick(picker) {
    //             const end = moment().endOf("day").valueOf();
    //             const start = moment().startOf("day").subtract(7, "days").valueOf();
    //
    //             picker.$emit("pick", [start, end]);
    //         }
    //     }, {
    //         text: "最近一个月",
    //         onClick(picker) {
    //             const end = moment().endOf("day").valueOf();
    //             const start = moment().startOf("day").subtract(1, "months").valueOf();
    //
    //             picker.$emit("pick", [start, end]);
    //         }
    //     }, {
    //         text: "最近三个月",
    //         onClick(picker) {
    //             const end = moment().endOf("day").valueOf();
    //             const start = moment().startOf("day").subtract(3, "months").valueOf();
    //
    //             picker.$emit("pick", [start, end]);
    //         }
    //     }, {
    //         text: "最近一年",
    //         onClick(picker) {
    //             const end = moment().endOf("day").valueOf();
    //             const start = moment().startOf("day").subtract(1, "years").valueOf();
    //
    //             picker.$emit("pick", [start, end]);
    //         }
    //     }]
    // }
  },
  mutations: {
    setTypeDict(state, data) {
      state.typeDict = data;
    },
    setThreatId(state, data) {
      state.threatId = data;
    }
    // setDistricts(state, data) {
    //     state.districts = data;
    // },
    // setMiits(state, data) {
    //     state.miits = data;
    // },
    // setAssetTypes(state, data) {
    //     state.assetTypes = data;
    // },
    // setDangerTypes(state, data) {
    //     state.dangerTypes = data;
    // },
    // setEventLevels(state, data) {
    //     state.eventLevels = data;
    // },
    // setEventSource(state, data) {
    //     state.eventSource = data;
    // },
    // setEventStatus(state, data) {
    //     state.eventStatus = data;
    // },
    // setEventTypes(state, data) {
    //     state.eventTypes = data;
    // },
    // setProtocole(state, data) {
    //     state.protocol = data;
    // },
    // setVulLevels(state, data) {
    //     state.vulLevels = data;
    // },
    // setTime(state, data) {
    //     state.time = data;
    // }
  },
  actions: {
    // getDict: ({commit}, params) => {
    //     getAssetThreatStatisticsDict(params).then(res => {
    //         if (res.data) {
    //             commit("setDistricts", res.data.districts);
    //             commit("setMiits", res.data.miits);
    //             commit("setAssetTypes", res.data.assetTypes);
    //             commit("setDangerTypes", res.data.dangerTypes);
    //             commit("setEventLevels", res.data.eventLevels);
    //             commit("setEventSource", res.data.eventSource);
    //             commit("setEventStatus", res.data.eventStatus);
    //             commit("setEventTypes", res.data.eventTypes);
    //             commit("setProtocole", res.data.protocol);
    //             commit("setVulLevels", res.data.vulLevels);
    //         }
    //     });
    // }
    getTypeDict: ({commit}) => {
      getButtonList().then(res => {
        commit("setTypeDict", res);
      });
    }
  }
};

export default dict;
